import * as React from "react";
import { IDragSource, Dnd, IDragImage, IDropTarget, IDrop } from "./Dnd";
import {IToken, GameToken } from "./Card";

export interface ITokenProps {
    token:IToken;
    valueChanged: (number: number) => void;
}
export class TokenComponent extends React.Component<ITokenProps, any> implements IDragSource, IDropTarget {
    dragType: string;
    dragImage: string;
    className:string;
    constructor(props: ITokenProps) {
        super(props);
        const name = GameToken[this.props.token.token].toLowerCase();
        this.dragType = `token/${name}`;
        this.className = `token ${name}`;
        if (this.props.token.canBeMoved) {
            this.className += " moveable";
        }
        this.dragImage = `/Content/tokens/hires/${name}_sm.png`;
    }
    allowDrop(dragType: string, effectAllowed: string): string {
        if (dragType === this.dragType) {
            return Dnd.move;
        }
        return null;
    }
    getDragImage(dragType: string): IDragImage {
        const img = new Image();
        img.src = this.dragImage;
        return { img: img, x: 25, y: 25 };
    }
    onDragComplete(): any {
        this.props.valueChanged(-1);
        return 1;
    }
    onDrop(drop:IDrop):boolean {
        this.props.valueChanged(1);
        return true;
    }
    render() {
        const token = this.props.token;
        let style = null;
        if (token.canBeMoved) {
            style = { left: token.x, top: token.y};
        };
        if (token.number) {
            return (
                <div className={this.className} style={style}
                    draggable={true}
                    onDragStart={(e) => { Dnd.dragStart(e, this, this.dragType, Dnd.move); }}
                    onDragOver={(e) => { Dnd.dragOver(e, this); }}
                    onDrop={(e) => { Dnd.drop(e, this); }}
                >{token.number === Infinity ? "" : token.number}</div>
            );
        }
        return (
            <div className={this.className} style={style}
                onDragOver={(e) => { Dnd.dragOver(e, this); }}
                onDrop={(e) => { Dnd.drop(e, this); }}
            >0</div>
        );
    }
}
